module.exports = __webpack_public_path__ + "img/bg.4157996e.png";